export default "/images/toggle-left.svg?6fc22f8668f3e7e2913f3d9e605fe24a";